import { useBridge } from '@completeanatomy/bridge';
import { useConfigService } from '@completeanatomy/config';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { kcGateway } from '../utils/keycloak';

export const useAuthentication = () => {
  const bridge = useBridge();
  const config = useConfigService();
  const navigate = useNavigate();
  const location = useLocation();

  const setupAuthentication = useCallback(async () => {
    const token = await kcGateway.getToken();

    kcGateway.addConfig(config);

    bridge?.emit('BridgeObjectChanged', {
      identifier: 'auth',
      keyPath: '',
      changes: {
        accessToken: token,
        identityToken: await kcGateway.getIdentityToken(),
      },
    });

    return token;
  }, [bridge, config]);

  const checkUserAuthentication = useCallback(async () => {
    const isUserExist = await kcGateway.userManager.getUser();

    if (!isUserExist) {
      const screen = sessionStorage.getItem('nextUrl');

      const isOnSignInPage = location.pathname === '/sign-in';

      /**
       * Don't redirect user to different page, if they are not authorized and landed on sign-in page
       */
      if (isOnSignInPage) {
        return false;
      }

      if (screen && screen !== '/') {
        navigate('/sign-in');
      } else {
        navigate('/models');
      }

      return false;
    }

    return true;
  }, [location.pathname, navigate]);

  return {
    setupAuthentication,
    checkUserAuthentication,
  };
};
